import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';
import CreateRelationshipCompanyForm from '@/components/forms/CreateRelationshipCompanyForm';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const RelationshipCompanyDrawer = () => {
	const dispatch = useDispatch();
	const { getFeatureFlags } = useFeatureFlagContext();
	const isRelationshipContactsEnabled = Boolean(getFeatureFlags('relationshipContacts')?.active);
	const isOpen = useSelector((state) => state.dialog?.open?.relationshipCompany);
	const open = isRelationshipContactsEnabled && isOpen;

	const handleClose = () => {
		dispatch(closeDialog('relationshipCompany'));
	};

	return (
		<FolioDrawer open={open} onClose={handleClose} canMaximise>
			{open && <CreateRelationshipCompanyForm onClose={handleClose} />}
		</FolioDrawer>
	);
};

export default RelationshipCompanyDrawer;
